import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import InitialSession from '../../components/abertura-chamado/initial-session';
import { BaSeLoadingPage } from '@base/react';

// eslint-disable-next-line sonarjs/cognitive-complexity
const AberturaChamado = () => {
  const { getEnv } = Sebrae.useEnv();
  const [glpiUrl, setGlpiUrl] = React.useState();
  const [tokenUserGLPI, setTokenUserGLPI] = React.useState();
  const [tokenAppGLPI, setTokenAppGLPI] = React.useState();
  const [token, setToken] = React.useState(false);
  const {
    isInitialized,
    isAuthenticated,
    login,
  } = Sebrae.useAuth();

  const start = React.useCallback(async () => {
    await getEnv('REACT_APP_TOKEN_USER_GLPI').then(setTokenUserGLPI);
    await getEnv('REACT_APP_TOKEN_APP_GLPI').then(setTokenAppGLPI);
    await getEnv('REACT_APP_GLPI_URL').then(setGlpiUrl);
  }, [getEnv]);

  React.useEffect(() => {
    start();
    if (glpiUrl && tokenAppGLPI && tokenUserGLPI) {
      setToken(true);
    }
  }, [glpiUrl, start, tokenAppGLPI, tokenUserGLPI]);

  if (isInitialized && !isAuthenticated) {
    login();
    return <BaSeLoadingPage />;
  }

  return (
    <>
      {token && (
        <InitialSession
          tokenUserGLPI={tokenUserGLPI}
          tokenAppGLPI={tokenAppGLPI}
          glpiUrl={glpiUrl}
        />
      )}
    </>
  );
};

export { AberturaChamado as default };
